module.exports = __webpack_public_path__ + "static/Mimi.Formal.Medium-f899bbfc6f474a945dc5f2230c125948.jpg";